import React from 'react';

const Loader = ({size="lg"}) => {
  return(
    <div className={`loader loader--${size}`}></div>
  )
}

export default Loader;